/* global MI */

/**
 * @constructor
 * @param {GameConfig} cfg
 * @returns {ReelPrinter}
 */
export default function ReelPrinter(cfg) {
    /** @type {GameConfig} */
    this._gameCfg = cfg;
};


/**
 * @param {SpinReel} reel
 */
ReelPrinter.prototype.print = function(reel) {

    for(var k = 0, l = reel.symbols.length; k < l; k++) {

        var i = reel.id;

        var pos = this._gameCfg.reelsPositions[i]["y"] + ((this._gameCfg.symbolHeight + this._gameCfg.symbolOffsetY) * k) + reel.shiftY;

        reel.symbols[k] && reel.symbols[k].getSprite() && reel.symbols[k].setPosY(
            pos,
            true
        );
    }
};